import { StatusBadge } from '@domain-group/suit-theme'

import type { PublicationBookingModel } from '@models/types'

const ApprovedArtworksBadge = (props: { artworkCounts: PublicationBookingModel['artwork_counts'] }) => {
  const { artworkCounts } = props
  const { approved, required } = artworkCounts || {}

  const approvedArtworkText = approved === required ? 'Approved' : `${approved}/${required} Approved`
  const approvedArtworkColor = approved === required ? 'green' : 'orange'

  return (
    <StatusBadge
      boxProps={{ marginLeft: 'large' }}
      color={required === 0 ? 'grey' : approvedArtworkColor}
      ghost
      text={required === 0 ? 'No Artworks' : approvedArtworkText}
    />
  )
}

export default ApprovedArtworksBadge
